const testimonials = {
  hero: {
    title: "What Our Clients Say",
    subtitle: "Real reviews from real customers who trust us with their homes.",
    stats: [
      { value: "100+", label: "Happy Clients" },
      { value: "5.0 ★", label: "Average Rating" },
      { value: "98%", label: "Would Recommend" },
    ],
  },
  filters: {
    all: "All",
    cleaning: "Cleaning",
    handyman: "Handyman",
    fiveStar: "5 Stars",
  },
  items: [
    {
      id: 1,
      name: "Maria Rodriguez",
      location: "Royal Palm Beach, FL",
      service: "Residential Cleaning",
      category: "cleaning",
      rating: 5,
      title: "Absolutely amazing service!",
      text: "Adry & Mich transformed my home! Every corner was spotless. They are professional, punctual, and truly care about the quality of their work. I've been using their service for 6 months and couldn't be happier.",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20latina%20woman%20portrait%20professional%20headshot%20warm%20natural%20light&width=80&height=80&seq=av1&orientation=squarish",
    },
    {
      id: 2,
      name: "James Thompson",
      location: "Wellington, FL",
      service: "Drywall Repair",
      category: "handyman",
      rating: 5,
      title: "Fixed my walls perfectly!",
      text: "I had several holes in my drywall from moving furniture. They came in, patched everything up, and you can't even tell there was damage. Fast, clean, and very affordable. Highly recommend!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20man%20portrait%20professional%20headshot%20warm%20natural%20light&width=80&height=80&seq=av2&orientation=squarish",
    },
    {
      id: 3,
      name: "Sarah Mitchell",
      location: "Royal Palm Beach, FL",
      service: "Airbnb Cleaning",
      category: "cleaning",
      rating: 5,
      title: "My Airbnb guests love it!",
      text: "Since I started using Adry & Mich for my Airbnb turnovers, my ratings have gone up to 5 stars consistently. They are reliable, thorough, and always ready on short notice. Best investment I've made!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20woman%20portrait%20professional%20headshot%20warm%20natural%20light%20blonde&width=80&height=80&seq=av3&orientation=squarish",
    },
    {
      id: 4,
      name: "Carlos Mendez",
      location: "West Palm Beach, FL",
      service: "Interior Painting",
      category: "handyman",
      rating: 5,
      title: "Great painting job!",
      text: "They painted my entire living room and hallway. The finish is perfect, clean lines, no drips. They protected all my furniture and cleaned up after themselves. Very professional team!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20latino%20man%20portrait%20professional%20headshot%20warm%20natural%20light&width=80&height=80&seq=av4&orientation=squarish",
    },
    {
      id: 5,
      name: "Linda Foster",
      location: "Palm Beach Gardens, FL",
      service: "Deep Cleaning",
      category: "cleaning",
      rating: 5,
      title: "My house has never been this clean!",
      text: "I requested a deep cleaning before a family gathering and they exceeded all my expectations. They cleaned areas I didn't even think about. The kitchen and bathrooms were absolutely sparkling!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20older%20woman%20portrait%20professional%20headshot%20warm%20natural%20light&width=80&height=80&seq=av5&orientation=squarish",
    },
    {
      id: 6,
      name: "Robert Kim",
      location: "Lake Worth, FL",
      service: "TV Mounting",
      category: "handyman",
      rating: 5,
      title: "Clean and professional installation!",
      text: "They mounted my 75-inch TV and managed all the cables perfectly. The wall looks clean and the TV is perfectly level. They were done in under an hour. Very impressed!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20asian%20man%20portrait%20professional%20headshot%20warm%20natural%20light&width=80&height=80&seq=av6&orientation=squarish",
    },
    {
      id: 7,
      name: "Patricia Gonzalez",
      location: "Royal Palm Beach, FL",
      service: "Move-out Cleaning",
      category: "cleaning",
      rating: 5,
      title: "Got my full deposit back!",
      text: "I hired them for a move-out cleaning and got my full security deposit back! The landlord was amazed at how clean the apartment was. Worth every penny. Thank you Adry & Mich!",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20latina%20woman%20portrait%20professional%20headshot%20warm%20natural%20light%20dark%20hair&width=80&height=80&seq=av7&orientation=squarish",
    },
    {
      id: 8,
      name: "David Williams",
      location: "Wellington, FL",
      service: "Pressure Washing",
      category: "handyman",
      rating: 5,
      title: "Driveway looks brand new!",
      text: "My driveway and patio were covered in years of grime. After their pressure washing service, it looks like new concrete! Fast service and very reasonable price. Will definitely use again.",
      avatar: "https://readdy.ai/api/search-image?query=friendly%20smiling%20man%20portrait%20professional%20headshot%20warm%20natural%20light%20brown%20hair&width=80&height=80&seq=av8&orientation=squarish",
    },
  ],
};

export default testimonials;
